// extracted by mini-css-extract-plugin
export default {"panelHidden":"Custom_panelHidden__YNYkM"};